module.exports = __webpack_public_path__ + "img/LIZ_Wallpaper.d869dd3e.png";